interface NumberBadgeProps {
  number: number | string;
  className?: string;
}

const NumberBadge = ({ number, className }: NumberBadgeProps) => {
  return (
    <span
      data-test="number-badge"
      className={`badge bg-danger rounded-pill d-flex align-items-center text-white ${className}`}
    >
      {number}
    </span>
  );
};

export default NumberBadge;
